/* SEC#23 — /pages/gastric-wellness redesign (sec-gw3-* sections).
   Each widget binds once (data-gw3-bound) and re-binds on shopify:section:load in the editor. */
(function () {
  'use strict';
  /* every section renders the <script> tag; only the first copy runs */
  if (window.__gw3Loaded) return;
  window.__gw3Loaded = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) {
    if (el.getAttribute('data-gw3-bound-' + key)) return false;
    el.setAttribute('data-gw3-bound-' + key, '1');
    return true;
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── smooth scroll for in-page CTAs ─────────────────────────── */
  function scrollToHash(hash) {
    var id = (hash || '').replace(/^#/, '');
    var dest = id && document.getElementById(id);
    if (!dest) return false;
    var header = document.querySelector('#se-header-root');
    var offset = header ? Math.min(header.getBoundingClientRect().height, 120) : 0;
    var top = dest.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    return true;
  }
  function initScroll(root) {
    $$('[data-gw3-scroll]', root).forEach(function (a) {
      if (!once(a, 'scroll')) return;
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#' && scrollToHash(href)) e.preventDefault();
      });
    });
  }

  /* ── self-check tally ───────────────────────────────────────── */
  function initSelfCheck(root) {
    $$('[data-gw3="selfcheck"]', root).forEach(function (sec) {
      if (!once(sec, 'check')) return;
      var tiles = $$('[data-gw3-tile]', sec);
      var tally = $('.gw3-tally', sec);
      if (!tally || !tiles.length) return;
      var total = tiles.length;
      var d = tally.dataset;
      var t1 = parseInt(d.t1, 10) || 2, t2 = parseInt(d.t2, 10) || 4;
      function update() {
        var n = tiles.filter(function (t) { return t.classList.contains('is-on'); }).length;
        var lvl = n === 0 ? 0 : n <= t1 ? 1 : n <= t2 ? 2 : 3;
        var map = { n: n, total: total };
        $('[data-gw3-count]', tally).textContent = n;
        $('[data-gw3-total]', tally).textContent = total;
        $('[data-gw3-verdict]', tally).textContent = fill(d['v' + lvl], map);
        $('[data-gw3-msg]', tally).textContent = fill(d['m' + lvl], map).replace(/\b1 signs\b/, '1 sign');
        $('[data-gw3-fill]', tally).style.width = (n / total * 100) + '%';
      }
      tiles.forEach(function (t) {
        t.addEventListener('click', function () {
          var on = t.classList.toggle('is-on');
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          update();
        });
      });
      update();
    });
  }

  /* ── money ──────────────────────────────────────────────────── */
  function formatMoney(cents, format, prefix) {
    var amount = (Math.round(cents) / 100);
    var fmt = format || '${{amount}}';
    var withDelims = function (n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    };
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(amount, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(amount, 0, '.', ',');
        default: return withDelims(amount, 2, ',', '.');
      }
    });
    return (prefix || '') + out;
  }

  /* ── cart ───────────────────────────────────────────────────── */
  function openSiteCart() {
    try { window.dispatchEvent(new CustomEvent('se:cart-updated')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    var link = document.querySelector('#se-header-root a[href="/cart"][data-cart-wired], a[href="/cart"][data-cart-wired]');
    if (link) { link.click(); return; }
    window.location.href = '/cart';
  }

  /* ── buy box ────────────────────────────────────────────────── */
  function initBuy(root) {
    $$('[data-gw3-offer]', root).forEach(function (offer) {
      if (!once(offer, 'buy')) return;
      var d = offer.dataset;
      var price = parseInt(d.price, 10) || 0;
      var days = parseInt(d.days, 10) || 30;
      var prefix = d.prefix || '';
      var fmt = d.moneyFormat || '${{amount}}';
      var money = function (c) { return formatMoney(c, fmt, prefix); };
      /* compact rows (tier sub-line, save badge) skip the CAD prefix so they fit on one line */
      var moneyShort = function (c) { return formatMoney(c, fmt, ''); };
      var tiers = $$('[data-gw3-tier]', offer);
      var planBtns = $$('[data-gw3-plan]', offer);
      var freqWrap = $('[data-gw3-freq]', offer);
      var freqBtns = $$('[data-gw3-sp]', offer);
      var atc = $('[data-gw3-atc]', offer);
      var err = $('[data-gw3-err]', offer);

      function isSub() { var on = planBtns.filter(function (b) { return b.classList.contains('is-on'); })[0]; return !!on && on.getAttribute('data-gw3-plan') === 'sub'; }
      function plan() { return freqBtns.filter(function (b) { return b.classList.contains('is-on'); })[0] || freqBtns[0]; }
      function pct() { var p = plan(); return p ? (parseFloat(p.getAttribute('data-pct')) || 0) : 0; }
      function active() { return tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0]; }

      /* per-bag: plan % first (rounded to the cent like Shopify), then the bulk amount per bag */
      function unit(bulk, sub) { var u = sub ? Math.round(price * (1 - pct() / 100)) : price; return u - bulk; }
      function quote(t, sub) {
        var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
        var bulk = parseInt(t.getAttribute('data-bulk'), 10) || 0;
        var msrp = price * q;
        var now = unit(bulk, sub) * q;
        var ot = unit(bulk, false) * q;
        return { q: q, msrp: msrp, now: now, ot: ot, perday: now / (q * days), days: q * days };
      }

      function select(list, btn, cls, attr) {
        list.forEach(function (b) { var on = b === btn; b.classList.toggle(cls, on); b.setAttribute(attr, on ? 'true' : 'false'); });
      }

      function render() {
        var sub = isSub();
        if (freqWrap) freqWrap.hidden = !sub;
        tiers.forEach(function (t) {
          var r = quote(t, sub);
          var saved = r.msrp - r.now;
          $('[data-gw3-now]', t).textContent = money(r.now);
          var was = $('[data-gw3-was]', t), save = $('[data-gw3-save]', t);
          was.hidden = saved <= 0; was.textContent = money(r.msrp);
          save.hidden = saved <= 0; save.textContent = fill(d.tSaveBadge, { amount: moneyShort(saved) });
          $('[data-gw3-tsub]', t).textContent = fill(d.tTierSub, { days: r.days, perday: moneyShort(r.perday) });
        });
        var a = quote(active(), sub);
        var perday = money(a.perday);
        $('[data-gw3-perday]', offer).innerHTML = perday + '<small>/day</small>';
        $('[data-gw3-plabel]', offer).textContent = sub ? d.tLabelSub : d.tLabelOt;
        var saveEl = $('[data-gw3-psave]', offer), tpl, amt;
        if (sub) { tpl = d.tSaveSub; amt = a.ot - a.now; }
        else if (a.msrp > a.ot) { tpl = d.tSaveOt; amt = a.msrp - a.ot; }
        else { tpl = d.tSaveNone; amt = 0; }
        var parts = String(tpl).split('[amount]');
        saveEl.textContent = '';
        parts.forEach(function (p, i) {
          if (i > 0) { var em = document.createElement('em'); em.textContent = money(amt); saveEl.appendChild(em); }
          saveEl.appendChild(document.createTextNode(p));
        });
        $('[data-gw3-note]', offer).textContent = fill(d.tNote, { q: a.q, bags: a.q === 1 ? 'bag' : 'bags', days: a.days });
        var ship = $('[data-gw3-ship]', offer);
        if (ship) ship.textContent = a.q >= 2 ? d.tShipMulti : d.tShipSingle;
        var wasEl = $('[data-gw3-atc-was]', offer), nowEl = $('[data-gw3-atc-now]', offer);
        if (nowEl) nowEl.textContent = money(a.now);
        if (wasEl) { wasEl.textContent = a.msrp > a.now ? money(a.msrp) : ''; wasEl.hidden = !(a.msrp > a.now); }
      }

      tiers.forEach(function (t) { t.addEventListener('click', function () { select(tiers, t, 'is-active', 'aria-checked'); render(); }); });
      planBtns.forEach(function (b) { b.addEventListener('click', function () { select(planBtns, b, 'is-on', 'aria-checked'); render(); }); });
      freqBtns.forEach(function (b) { b.addEventListener('click', function () { select(freqBtns, b, 'is-on', 'aria-checked'); render(); }); });

      /* arrow keys inside each radiogroup */
      $$('[role="radiogroup"]', offer).forEach(function (g) {
        g.addEventListener('keydown', function (e) {
          if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
          var items = $$('[role="radio"]', g); var i = items.indexOf(document.activeElement); if (i < 0) return;
          e.preventDefault();
          var n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length];
          n.focus(); n.click();
        });
      });

      if (atc) atc.addEventListener('click', function () {
        var a = active(); var q = parseInt(a.getAttribute('data-qty'), 10) || 1;
        var item = { id: parseInt(d.variant, 10), quantity: q };
        var p = isSub() && plan();
        if (p) item.selling_plan = parseInt(p.getAttribute('data-gw3-sp'), 10);
        atc.setAttribute('aria-busy', 'true');
        if (err) err.hidden = true;
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
          .then(function () {
            atc.removeAttribute('aria-busy');
            if (d.mode === 'checkout') { window.location.href = '/checkout'; return; }
            openSiteCart();
          })
          .catch(function () { atc.removeAttribute('aria-busy'); if (err) err.hidden = false; });
      });

      render();
    });
  }

  /* ── buy-box gallery ────────────────────────────────────────── */
  function initGallery(root) {
    $$('[data-gw3-gallery]', root).forEach(function (g) {
      if (!once(g, 'gallery')) return;
      var slides = $$('[data-gw3-slide]', g), thumbs = $$('[data-gw3-thumb]', g), i = 0;
      if (slides.length < 2) return;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      }
      var prev = $('[data-gw3-gprev]', g), next = $('[data-gw3-gnext]', g);
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var x0 = null, stage = $('.gw3-gallery__stage', g);
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      go(0);
    });
  }

  /* ── Day 0 / Day 30 slider ──────────────────────────────────── */
  function initSlider(root) {
    $$('[data-gw3-slider]', root).forEach(function (s) {
      if (!once(s, 'slider')) return;
      var track = $('[data-gw3-track]', s), slides = $$('.gw3-trial', s);
      var prev = $('[data-gw3-prev]', s), next = $('[data-gw3-next]', s), dotsWrap = $('[data-gw3-dots]', s);
      var i = 0;
      function perView() { return window.innerWidth >= 768 ? 2 : 1; }
      function maxIdx() { return Math.max(0, slides.length - perView()); }
      function buildDots() {
        dotsWrap.innerHTML = '';
        for (var k = 0; k <= maxIdx(); k++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'gw3-dz__dot'; b.setAttribute('aria-label', 'Go to slide ' + (k + 1));
          (function (n) { b.addEventListener('click', function () { go(n); }); })(k);
          dotsWrap.appendChild(b);
        }
      }
      function go(n) {
        var m = maxIdx();
        i = n < 0 ? m : n > m ? 0 : n;   /* loops, so both arrows always work (as in the design) */
        var w = slides[0] ? slides[0].getBoundingClientRect().width : 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        track.style.transform = 'translateX(' + (-(w + gap) * i) + 'px)';
        prev.disabled = next.disabled = maxIdx() === 0;
        $$('.gw3-dz__dot', dotsWrap).forEach(function (dot, k) { dot.classList.toggle('is-active', k === i); });
        slides.forEach(function (sl, k) { sl.setAttribute('aria-hidden', (k >= i && k < i + perView()) ? 'false' : 'true'); });
      }
      prev.addEventListener('click', function () { go(i - 1); });
      next.addEventListener('click', function () { go(i + 1); });
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      /* off-screen slides never intersect the viewport, so lazy images would load only on
         arrival; once the slider is near the viewport, load them all */
      var imgs = $$('img[loading="lazy"]', s);
      if (imgs.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (e) { return e.isIntersecting; })) { imgs.forEach(function (im) { im.loading = 'eager'; }); io.disconnect(); }
        }, { rootMargin: '400px 0px' });
        io.observe(s);
      }
      var lastPer = perView();
      window.addEventListener('resize', function () { if (perView() !== lastPer) { lastPer = perView(); buildDots(); } go(i); });
      buildDots(); go(0);
    });
  }

  /* ── FAQ ────────────────────────────────────────────────────── */
  function initFaq(root) {
    $$('[data-gw3-faq]', root).forEach(function (btn) {
      if (!once(btn, 'faq')) return;
      btn.addEventListener('click', function () {
        var item = btn.closest('.gw3-faq__item');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ── live Stamped rating + review count ─────────────────────── */
  var stampedCache = {};
  function stampedStats(ids, key, sid) {
    var k = ids + '|' + key;
    if (!stampedCache[k]) {
      stampedCache[k] = fetch('https://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=false', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productIds: ids.split(',').map(function (id) { return { productId: id.trim() }; }).filter(function (x) { return x.productId; }), apiKey: key, storeUrl: sid, sId: sid })
      }).then(function (r) { if (!r.ok) throw new Error('stamped ' + r.status); return r.json(); })
        .then(function (list) {
          var count = 0, sum = 0;
          (list || []).forEach(function (p) { var c = +p.count || 0; count += c; sum += (+p.rating || 0) * c; });
          if (!count) throw new Error('no reviews');
          return { rating: (Math.round(sum / count * 10) / 10).toFixed(1), count: count };
        });
    }
    return stampedCache[k];
  }
  function initStamped(root) {
    $$('[data-gw3-stamped]', root).forEach(function (el) {
      if (!once(el, 'stamped')) return;
      var ids = el.getAttribute('data-gw3-stamped');
      if (!ids) return;
      stampedStats(ids, el.getAttribute('data-gw3-key'), el.getAttribute('data-gw3-sid')).then(function (s) {
        $$('[data-gw3-r]', el).forEach(function (n) { n.textContent = s.rating; });
        $$('[data-gw3-c]', el).forEach(function (n) { n.textContent = s.count; });
      }).catch(function () { /* keep the server-rendered fallback */ });
    });
  }

  function init(root) {
    initScroll(root); initSelfCheck(root); initBuy(root); initGallery(root); initSlider(root); initFaq(root); initStamped(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
